import EconfModal from "@/modules/NFe/components/EconfModal.vue";
import { podeAbrirEconf } from "@/modules/NFe/services/econf";

export default {
  components: { EconfModal },
  data() {
    return { econfAberto: false, notaEconf: null };
  },
  methods: {
    podeAbrirEconf,
    abrirEconf(nota) {
      if (!podeAbrirEconf(nota)) {
        this.$toast.warning(
          "Selecione uma NF-e/NFC-e autorizada com chave de acesso. Notas canceladas permitem consultar o histórico."
        );
        return;
      }
      this.notaEconf = { ...nota };
      this.econfAberto = true;
    },
  },
};
